import React from 'react';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  className?: string;
}

export const Label: React.FC<LabelProps> = ({ className = '', children, ...props }) => {
  const baseClasses = 'block text-sm font-medium text-gray-700';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <label className={classes} {...props}>
      {children}
    </label>
  );
};
